var exports = {
  "container": "x31de4314--992ade--container",
  "wrapper": "x31de4314--992ade--wrapper",
  "breadcrumbs": "x31de4314--992ade--breadcrumbs",
  "breadcrumbs-delimiter": "x31de4314--992ade--breadcrumbs-delimiter",
  "breadcrumbs-link": "x31de4314--992ade--breadcrumbs-link",
  "title": "x31de4314--992ade--title",
  "content": "x31de4314--992ade--content",
  "content-logotype": "x31de4314--992ade--content-logotype",
  "content-main": "x31de4314--992ade--content-main",
  "content-info": "x31de4314--992ade--content-info",
  "content-projects": "x31de4314--992ade--content-projects",
  "content-projectsLabel": "x31de4314--992ade--content-projectsLabel",
  "content-projectsData": "x31de4314--992ade--content-projectsData",
  "content-projectsList": "x31de4314--992ade--content-projectsList",
  "content-description": "x31de4314--992ade--content-description",
};

module.exports = exports;
